import React from 'react';

// Investment Focus - Categories. 56x56 gradient-bordered tile (the frame is part
// of the artwork), glyph exactly as Figma drew it. Gradient ids are per-instance
// (useId) so several No*/Focus icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const CategoriesIcon = ({ size = 56 }) => {
  const uid = React.useId();
  const g = (n) => `categories_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="55" height="55" rx="11.5" stroke={`url(#${g(0)})`} />
      <path
        d="M28 9C31.3333 13 33 18.6667 33 26V34H23V26C23 18.6667 24.6667 13 28 9Z"
        stroke={`url(#${g(1)})`}
      />
      <circle cx="28" cy="21" r="2.5" stroke={`url(#${g(2)})`} />
      <path d="M23 31L18 39L23 37V31Z" stroke={`url(#${g(3)})`} />
      <path d="M33 31L38 39L33 37V31Z" stroke={`url(#${g(4)})`} />
      <path d="M26 34L28 40L30 34H26Z" stroke={`url(#${g(5)})`} />
      <defs>
        <linearGradient id={g(0)} x1="28" y1="0" x2="28" y2="56" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="28" y1="9" x2="28" y2="34" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="28" y1="18" x2="28" y2="24" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="20.5" y1="31" x2="20.5" y2="39" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(4)} x1="35.5" y1="31" x2="35.5" y2="39" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(5)} x1="28" y1="34" x2="28" y2="40" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CategoriesIcon;
